import { useGetAllTabsDashboardData } from "@features/ax/dashboard/hooks";
import { logEvent } from "@shared/analytics/analytics";
import { useEffect } from "react";
import { ActiveOperationsSection } from "./activeOperations";
import { AssetAnalysisSection } from "./assetAnalysis";
import { CriticalAlertsSection } from "./criticalAlertsSection";
import { PerformanceMetricsSection } from "./performanceMetrics";
import { WorkOrderManagementSection } from "./workOrderManagement";

const OMDashboard = () => {
  useEffect(() => {
    logEvent("O&M Dashboard Viewed", {});
  }, []);
  const { data: omDashboardData } = useGetAllTabsDashboardData("om");
  return (
    <div className="space-y-6">
      <CriticalAlertsSection data={omDashboardData} />
      <PerformanceMetricsSection data={omDashboardData} />
      <WorkOrderManagementSection data={omDashboardData} />
      <AssetAnalysisSection data={omDashboardData} />
      <ActiveOperationsSection data={omDashboardData} />
      {/* <MonitoringTeamSection data={omDashboardData} /> */}
    </div>
  );
};

export default OMDashboard;
